"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _Checkbox = _interopRequireDefault(require("../../../Checkbox"));
var _tableContext = require("../../Context/tableContext");
var _ykbUtils = require("ykb-utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function RowSelection(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    disabled = _ref.disabled,
    rowKey = _ref.rowKey,
    checkStrictly = _ref.checkStrictly,
    isFiltered = _ref.isFiltered;
  var _useState = (0, _react.useState)(!!_tableContext.eventHub.getState('selectedRowKeys')[rowKey]),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var disabledRef = (0, _react.useRef)(disabled);
  disabledRef.current = disabled;
  var isFilteredRef = (0, _react.useRef)(isFiltered);
  function onChange() {
    var newValue = !value;
    setInnerValue(newValue);
    _tableContext.eventHub.emit('update.rowSelection.onChange', rowKey, newValue);
  }
  function setInnerValue(_value) {
    setValue(_value);
  }
  (0, _react.useEffect)(function () {
    var unsubscriber = [];
    if (rowKey != 'header-selection') {
      unsubscriber.push(_tableContext.eventHub.on('listen.rowSelection.change', function (value) {
        if (!disabledRef.current && !isFilteredRef.current) {
          setInnerValue(value);
          if (value == true) {
            return rowKey;
          }
        }
      }));
    } else {
      unsubscriber.push(_tableContext.eventHub.on('listen.rowSelection.header.change', function (value) {
        if (!disabledRef.current) {
          setInnerValue(value);
        }
      }));
    }
    unsubscriber.push(_tableContext.eventHub.on("update.rowSelection.selectedRowKeys.".concat(rowKey), function (value) {
      if (!disabledRef.current && !isFilteredRef.current) {
        setInnerValue(value);
      }
    }));
    unsubscriber.push(_tableContext.eventHub.on('clear.rowSelection.selectedRowKeys', function () {
      setInnerValue(false);
    }));
    return function () {
      unsubscriber.forEach(function (fn) {
        return fn();
      });
    };
  }, []);
  (0, _react.useEffect)(function () {
    disabledRef.current = disabled;
    if (disabled) {
      setInnerValue(false);
    }
  }, [disabled]);
  (0, _react.useEffect)(function () {
    isFilteredRef.current = isFiltered;
  }, [isFiltered]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "ykb-ui-table-row-selection-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_Checkbox.default
  // type="checkbox"
  , {
    className: className + ' cursor-pointer',
    onChange: onChange,
    checked: value,
    disabled: disabled,
    checkStrictly: checkStrictly
  }));
}
var RowSelection2 = exports.default = /*#__PURE__*/function (_React$PureComponent) {
  function RowSelection2(props) {
    var _this;
    (0, _classCallCheck2.default)(this, RowSelection2);
    _this = _callSuper(this, RowSelection2, [props]);
    _this.onChange = _this.onChange.bind(_this);
    _this.setInnerValue = _this.setInnerValue.bind(_this);
    var rowKey = props.rowKey,
      disabled = props.disabled,
      isFiltered = props.isFiltered;
    _this.state = {
      value: !!_tableContext.eventHub.getState('selectedRowKeys')[rowKey]
    };
    _this.disabledRef = disabled;
    _this.isFilteredRef = isFiltered;
    var that = _this;
    _this.unsubscriber = [_tableContext.eventHub.on("update.rowSelection.selectedRowKeys.".concat(_this.rowKey), function (value) {
      if (!that.disabledRef && !that.isFilteredRef) {
        that.setInnerValue(value);
      }
    }), _tableContext.eventHub.on('clear.rowSelection.selectedRowKeys', function () {
      that.setInnerValue(false);
    })];
    if (rowKey != 'header-selection') {
      _this.unsubscriber.push(_tableContext.eventHub.on('listen.rowSelection.change', function (value) {
        if (!that.disabledRef && !that.isFilteredRef) {
          that.setInnerValue(value);
          if (value == true) {
            return rowKey;
          }
        }
      }));
    } else {
      _this.unsubscriber.push(_tableContext.eventHub.on('listen.rowSelection.header.change', function (value) {
        if (!that.disabledRef) {
          that.setInnerValue(value);
        }
      }));
    }
    return _this;
  }
  (0, _inherits2.default)(RowSelection2, _React$PureComponent);
  return (0, _createClass2.default)(RowSelection2, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(newProps) {
      var disabled = newProps.disabled,
        isFiltered = newProps.isFiltered;
      if (!(0, _ykbUtils.isEqual)(disabled, newProps.disabled)) {
        this.disabledRef = newProps.disabled;
        if (!newProps.disabled) {
          this.setInnerValue(false);
        }
      }
      if (!(0, _ykbUtils.isEqual)(isFiltered, newProps.isFiltered)) {
        this.isFiltered = newProps.isFiltered;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unsubscriber.forEach(function (fn) {
        return fn();
      });
    }
  }, {
    key: "onChange",
    value: function onChange() {
      var value = this.state.value;
      var rowKey = this.props.rowKey;
      var newValue = !value;
      this.setInnerValue(newValue);
      _tableContext.eventHub.emit('update.rowSelection.onChange', rowKey, newValue);
    }
  }, {
    key: "setInnerValue",
    value: function setInnerValue(_value) {
      this.setState({
        value: _value
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        className = _this$props.className,
        disabled = _this$props.disabled,
        checkStrictly = _this$props.checkStrictly;
      var value = this.state.value;
      this.disabledRef = disabled;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "ykb-ui-table-row-selection-wrapper"
      }, /*#__PURE__*/_react.default.createElement(_Checkbox.default
      // type="checkbox"
      , {
        className: className + ' cursor-pointer',
        onChange: this.onChange,
        checked: value,
        disabled: disabled,
        checkStrictly: checkStrictly
      }));
    }
  }]);
}(_react.default.PureComponent);